import api from './api';

export interface EmailAccount {
  _id?: string;
  name: string;
  email: string;
  host: string;
  port: number;
  secure: boolean;
  user: string;
  pass: string;
  createdAt?: string;
  updatedAt?: string;
}

class EmailAccountService {
  // Tüm hesapları getir
  async getAccounts(): Promise<EmailAccount[]> {
    try {
      const response = await api.get('/email-accounts');
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error('❌ Error fetching email accounts:', error);
      return [];
    }
  }

  // Yeni hesap ekle
  async createAccount(accountData: Omit<EmailAccount, '_id'>): Promise<EmailAccount | null> {
    try {
      const response = await api.post('/email-accounts', accountData);
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.error('❌ Error creating email account:', error);
      throw error;
    }
  }

  // Hesap güncelle
  async updateAccount(id: string, accountData: Omit<EmailAccount, '_id'>): Promise<EmailAccount | null> {
    try {
      const response = await api.put(`/email-accounts/${id}`, accountData);
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.error('❌ Error updating email account:', error);
      throw error;
    }
  }

  // Hesap sil
  async deleteAccount(id: string): Promise<boolean> {
    try {
      const response = await api.delete(`/email-accounts/${id}`);
      return response.data.success;
    } catch (error) {
      console.error('❌ Error deleting email account:', error);
      return false;
    }
  }

  // SMTP bağlantısını test et
  async testConnection(accountData: Partial<EmailAccount>): Promise<{ success: boolean; message: string }> {
    try {
      const response = await api.post('/email-accounts/test', accountData);
      return {
        success: response.data?.success || false,
        message: response.data?.message || 'SMTP Bağlantısı başarılı'
      };
    } catch (error: any) {
      console.error('❌ SMTP Connection test error:', error);
      return {
        success: false,
        message: error?.response?.data?.message || 'Bağlantı testi sırasında hata oluştu'
      };
    }
  }
}

const emailAccountService = new EmailAccountService();
export default emailAccountService;
